<!--
 * @Author:MX
 * @Date: 2020-08-01 11:25:22
 * @Description: 首次登陆修改密码
-->
<template>
  <div class="SetPasswordCom">
    <div class="title">{{ $lang('修改密码') }}</div>
    <el-form ref="forgetPwdForm" :model="forgetPwdForm" :rules="rules">
      <el-form-item prop="verifyCode">
        <el-input v-model="userInfo.account" :placeholder="$lang('请输入账号')" type="text" >
            <i slot="prefix" class="iconfont el-input__icon iconyonghuming"></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="pass">
        <el-input v-model="forgetPwdForm.pass" :placeholder="$lang('请输入新密码')"  type="password" >
            <i slot="prefix" class="iconfont el-input__icon iconmima1"></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="checkPass">
        <el-input v-model="forgetPwdForm.checkPass" :placeholder="$lang('确认新密码')" autocomplete="off"  type="password" >
            <i slot="prefix" class="iconfont el-input__icon iconmima1"></i>
        </el-input>
      </el-form-item>
    </el-form>
    <el-button type="primary" class="login-btn" @click="submitForm()">{{ $lang('确认修改') }}</el-button>
  </div>
</template>

<script type="text/javascript">
import { mapActions } from 'vuex'
import * as Api from '@api/base/public'
import { RESPONSE_SUCCESS } from '@constants'
export default {
  name: 'SetPasswordCom',
  data() {
    const validatePass = (rule, value, callback) => {
      const reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[_\W])[a-zA-Z0-9_\W]{8,}$/
      if (value === '') {
        callback(new Error(this.$lang('请输入密码')))
      } else if (!(reg.test(value) && (/\d/).test(value))) {
        callback(new Error(this.$lang('长度8位及以上，包含大、小写字母，数字，特殊字符')))
      } else {
        if (this.forgetPwdForm.checkPass !== '') {
          this.$refs.forgetPwdForm.validateField('checkPass')
        }
        callback()
      }
    }
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$lang('请再次输入密码')))
      } else if (value !== this.forgetPwdForm.pass) {
        callback(new Error(this.$lang('两次输入密码不一致!')))
      } else {
        callback()
      }
    }
    return {
      forgetPwdForm: {
        pass: '',
        checkPass: '',
      },
      rules: {
        pass: [{ validator: validatePass, trigger: 'blur' }],
        checkPass: [{ validator: validatePass2, trigger: 'blur' }],
      },
    }
  },
  computed: {
    // 用户信息
    userInfo() {
      return this.$store.state.base.user || {}
    },
  },
  methods: {
    ...mapActions(['LOGIN_OUT']),
    async submitForm() {
      const oldPwd = localStorage.getItem('oldPwd')
      if (oldPwd) {
        try {
          if (oldPwd === this.forgetPwdForm.pass) {
            this.$message.error(this.$lang('新密码不能与当前正在使用的密码一致!'))
            return
          }
          const valid = await this.$refs.forgetPwdForm.validate()
          if (valid) {
            // 解构对象
            const { pass } = this.forgetPwdForm
            // 获取参数
            // const params = { oldPwd, pwd: pass }
            const params = {
              oldPwd: this.$Base64.encode(oldPwd + 'jadada236t2'),
              pwd: this.$Base64.encode(pass + 'jadada236t2'),
            }
            // 请求登录
            const { code, msg } = await Api.CHANGE_PASSWORD(params)
            // 处理返回数据
            if (code && code === RESPONSE_SUCCESS) {
              this.$message.success(this.$lang('修改成功'))
              this.$common.setCookie('account', '')
              this.$common.setCookie('pwd', '')
              this.LOGIN_OUT().then(res => {
                // this.$router.push({ path: '/login' })
                this.$emit('setpasswordSuc')
              })
            } else {
              this.$message.error(msg)
            }
          }
        } catch (error) {
          console.log('submitForm::error', error)
        }
      } else {
        // this.$router.push({ path: '/login' })
        this.$emit('setpasswordSuc')
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.codeTimer)
  },
}
</script>

<style lang="scss" scoped>
.SetPasswordCom{
     .title{
        font-size: 20px;
        font-weight: 500;
        line-height: 30px;
        text-align: center;
        letter-spacing: 6px;
        margin-bottom: 40px;
        height: 70px;
    }
    .login-btn{
         width: 100%;
        padding: 0;
        height: 40px;
        line-height: 40px;
        border: none;
        border-radius: 4px;
        background:linear-gradient(90deg,rgba(230,0,18,1) 0%,rgba(230,0,18,1) 100%);
         margin-top: 40px;
        font-size: 16px;

    }
    .getPhoneCode{
            position: absolute;
            cursor: pointer;
            right: 0;
            padding: 0 15px;
            bottom: 0px;
            color: #e60012;
    }
    .iconfont.iconfanhui {
        position: absolute;
        left: 40px;
        font-size: 25px;
        cursor: pointer;
        color: #e60012;
    }
}
</style>
